import React from 'react';
import { classNames } from '@fullstory/util/fmt';
import { IconButton, Icon, IconProps } from '@fullstory/components';
import css from './index.module.scss';
import { intl } from '@fullstory/intl';

type ServerEventButtonProps = {
  iconProps?: Partial<IconProps>;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isHovered?: boolean;
  isExpanded?: boolean;
  onClick?: () => void;
};

export const ServerEventButton: React.FC<ServerEventButtonProps> = ({
  iconProps,
  onMouseEnter,
  onMouseLeave,
  isHovered,
  isExpanded,
  onClick,
}) => (
  <div
    data-component="ServerEventButton"
    className={classNames(css.wrapper, css.border)}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >
    <div className={classNames(css.baseLayer)}>
      {!onClick ? (
        <Icon name="server" size={20} color="secondary" {...iconProps} />
      ) : (
        <IconButton
          className={
            isHovered || isExpanded ? classNames(css.expandedServerEventBtn) : css.serverEventBtn
          }
          size={isHovered || isExpanded ? 'large' : 'small'}
          iconName={
            !isHovered && !isExpanded ? 'server' : isExpanded ? 'chevron-up' : 'chevron-down'
          }
          title={intl.formatMessage(
            {
              defaultMessage:
                '{isExpanded, select, true {Collapse} other {Expand}} Server Event Information',
              id: 'cdLzfr',
            },
            { isExpanded },
          )}
          onClick={onClick}
        />
      )}
    </div>
  </div>
);
